const filterTitles = document.querySelectorAll( '.filter-title' );

filterTitles.forEach( ( title ) => {
	title.addEventListener( 'click', ( toggle ) => {
		const group = title.parentNode;
		const content = group.querySelector( '.facetwp-facet' );
		group.classList.toggle( 'open' );
		if ( group.classList.contains( 'open' ) ) {
			content.style.height = `${ content.scrollHeight }px`;
		} else {
			content.style.height = '0';
		}
	} );
} );

document.addEventListener( 'facetwp-loaded', function () {
	const facetsArray = Object.keys( FWP.facets );
	let activeFilters = false;

	facetsArray.forEach( ( facet ) => {
		if ( 'pagination' !== facet && FWP.facets[ facet ].length > 0 ) {
			activeFilters = true;
		}
	} );

	if ( document.querySelector( '.overview-news' ) && document.querySelector( '.filters-wrapper' ) ) {
		const resetFilters = document.querySelector( '.reset-filters' );
		if ( activeFilters ) {
			resetFilters.classList.remove( 'hidden' );
		} else {
			resetFilters.classList.add( 'hidden' );
		}
	}

	if ( document.querySelector( '.overview-vacancies' ) ) {
		const allFilters = document.querySelector( '.reset-filters-button' );
		if ( activeFilters ) {
			allFilters.classList.remove( 'checked' );
		} else {
			allFilters.classList.add( 'checked' );
		}
	}

	if ( document.querySelector( '.search' ) ) {
		const currentFilters = document.querySelector( '.filter-current' );
		if ( activeFilters ) {
			currentFilters.classList.remove( 'hidden' );
		} else {
			currentFilters.classList.add( 'hidden' );
		}
	}
} );
